import { render, staticRenderFns } from "./EditTypologySizeForTax.vue?vue&type=template&id=c70dd362&scoped=true&"
import script from "./EditTypologySizeForTax.vue?vue&type=script&lang=js&"
export * from "./EditTypologySizeForTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70dd362",
  null
  
)

export default component.exports